import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import {
	Card,
	CardContent,
	CardActions,
	Typography,
	Grid,
	Divider,
	CardActionArea,
} from '@material-ui/core';
import AttachMoney from '@material-ui/icons/AttachMoney';
import Equalizer from '@material-ui/icons/Equalizer';
import { withRouter } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
	root: {},
	imageContainer: {
		height: 64,
		width: 64,
		margin: '0 auto',
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: '5px',
		overflow: 'hidden',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: '10px',
	},
	image: {
		width: '100%',
	},
	statsItem: {
		display: 'flex',
		alignItems: 'center',
	},
	statsIcon: {
		color: theme.palette.icon,
		marginRight: theme.spacing(1),
	},
}));

const ProductCard = props => {
	const { className, product, history, staticContext, ...rest } = props;

	const classes = useStyles();

	const handleClick = () => {
		history.push(`/products/edit-product/${product._id}`);
	};

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<CardActionArea onClick={handleClick}>
				<CardContent>
					<div className={classes.imageContainer}>
						<img
							alt='Product'
							className={classes.image}
							src={
								(product.thumbnail && product.thumbnail.url) ||
								'/images/undraw_page_not_found_su7k.svg'
							}
						/>
					</div>
					<Typography align='center' gutterBottom variant='h4'>
						{product.name}
					</Typography>
					<Typography align='center' variant='body1'>
						{product.description.length > 20
							? `${product.description.substr(0, 20)}...`
							: product.description}
					</Typography>
				</CardContent>
				<Divider />
			</CardActionArea>

			<CardActions>
				<Grid container justify='space-between'>
					<Grid className={classes.statsItem} item>
						<AttachMoney className={classes.statsIcon} />
						<Typography display='inline' variant='body2'>
							价格: {product.currentPrice}
						</Typography>
					</Grid>
					<Grid className={classes.statsItem} item>
						<Equalizer className={classes.statsIcon} />
						<Typography display='inline' variant='body2'>
							销量: {product.salesVolume}
						</Typography>
					</Grid>
				</Grid>
			</CardActions>
		</Card>
	);
};

ProductCard.propTypes = {
	className: PropTypes.string,
	product: PropTypes.object.isRequired,
};

export default withRouter(ProductCard);
